import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { NaturalezaJuridica } from './naturalezas-juridica.model';

@Injectable({
  providedIn: 'root'
})
export class NaturalezaJuridicaService {
  url: string;
  token: string;
  endpoint: string = 'naturalezasJuridica';

  constructor(private http: HttpClient) {}

  getNaturalezaJuridica(): Observable<NaturalezaJuridica[]> {
    return this.http.get<NaturalezaJuridica[]>(
      `${this.url}/${this.endpoint}/`,
      {
        params: { token: this.token }
      }
    );
  }

  addNaturalezaJuridica(
    naturalezaJuridica: NaturalezaJuridica
  ): Observable<NaturalezaJuridica> {
    return this.http.post<NaturalezaJuridica>(`${this.url}/${this.endpoint}/`, {
      ...naturalezaJuridica
    });
  }

  changeNaturalezaJuridica(
    p: NaturalezaJuridica
  ): Observable<NaturalezaJuridica> {
    return this.http.patch<NaturalezaJuridica>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        naturalezaJuridica: p,
        token: this.token
      }
    );
  }

  deleteNaturalezaJuridica(
    p: NaturalezaJuridica
  ): Observable<NaturalezaJuridica> {
    return this.http.delete<NaturalezaJuridica>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
